export const EXSBDELIVERY_SHOW_RESET = 'EXSBDELIVERY_SHOW_RESET'
export const EXSBDELIVERY_SHOW_SET_ERROR = 'EXSBDELIVERY_SHOW_SET_ERROR'
export const EXSBDELIVERY_SHOW_SET_RETRIEVED = 'EXSBDELIVERY_SHOW_SET_RETRIEVED'
export const EXSBDELIVERY_SHOW_TOGGLE_LOADING = 'EXSBDELIVERY_SHOW_TOGGLE_LOADING'
